import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageActions } from '@hooks';
import {
  createDirectChildOrganisation,
  resetDirectChildOrganisationCreation,
} from '@redux/directChildOrganisationAdministration/actions';
import { selectDirectChildOrganisationCreation } from '@redux/directChildOrganisationAdministration/selectors';
import OrganisationWizard from '../Hospitals/Wizard';
import { setCurrentScreen, screens } from '../../../analytics';

const NewDirectChildOrganisation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const creation = useSelector(selectDirectChildOrganisationCreation);
  const title = t('directChildOrganisationAdministration:routes.newOrganisation');

  const { hasPageActionsProvider } = usePageActions({ title, showClose: true });

  useEffect(() => {
    setCurrentScreen(screens.ADMINISTRATION_DIRECT_CHILD_ORGANISATION_CREATION);
  }, []);

  useEffect(() => {
    if (creation.status === 'success') {
      dispatch(resetDirectChildOrganisationCreation());
      history.replace('/administration/child-organisations');
    }
  }, [creation.status, dispatch, history]);

  const onCompleted = useCallback(
    formData => {
      dispatch(
        createDirectChildOrganisation(formData.details.hospitalName, formData.details.language),
      );
    },
    [dispatch],
  );

  return (
    <>
      {!hasPageActionsProvider ? <h1>{title}</h1> : null}
      <OrganisationWizard submitting={creation.status === 'loading'} onCompleted={onCompleted} />
    </>
  );
};

export default NewDirectChildOrganisation;
